import { Trash2 } from "lucide-react";
import { cn } from "@/shared/lib/utils";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/ui/AlertDialog";
import { Button } from "@/shared/ui/Button";

type DeleteConfirmationDialogProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
  itemName: string
  title?: string
  description?: string
  descriptionClassName?: string
  confirmLabel?: string
  cancelLabel?: string
};

const DeleteConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  itemName,
  title = "Confirmer la suppression",
  description,
  descriptionClassName,
  confirmLabel = "Supprimer",
  cancelLabel = "Annuler",
}: DeleteConfirmationDialogProps) => {
  const defaultDescription = `Êtes-vous sûr de vouloir supprimer "${itemName}" ? Cette action est irréversible.`;

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-4 w-full bg-red-100 p-4 rounded-xl text-lg font-semibold text-destructive">
            <Trash2 size={24} className="text-destructive" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className={cn("flex flex-col gap-4 mt-3 whitespace-break-spaces", descriptionClassName)}>
            {description || defaultDescription}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose} disabled={isLoading}>
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button variant="destructive" onClick={onConfirm} disabled={isLoading}>
              {confirmLabel}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { DeleteConfirmationDialog };
